import app from 'flarum/forum/app';

/** The My Community overview (members, activity, Naira rate...), shared and cached for a minute. */
let cache = null;
let cachedAt = 0;
let pending = null;
export function overview() {
  return cache;
}
export function loadOverview() {
  if (cache && Date.now() - cachedAt < 60000) return Promise.resolve(cache);
  if (pending) return pending;
  pending = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/voucha-community/overview',
    errorHandler: () => {}
  }).then(r => {
    cache = r;
    cachedAt = Date.now();
    return r;
  }).finally(() => pending = null);
  return pending;
}
export function clearOverview() {
  cache = null;
}
flarum.reg.add('voucha-community', 'common/overview', { overview: overview,loadOverview: loadOverview,clearOverview: clearOverview, });